import { render, staticRenderFns } from "./FuturProprietaire.vue?vue&type=template&id=1f94ce4e&"
import script from "./FuturProprietaire.vue?vue&type=script&lang=js&"
export * from "./FuturProprietaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FuturProprietaire.vue"
export default component.exports